import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap'

const PopoverComponent = ({ name, title, tooltip, toolTipPosition }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const triggerRef = useRef(null)
  const popoverRef = useRef(null)
  const targetIdRef = useRef(
    `targetHelpIcon-${name}`
  )

  const toggle = () => {
    setIsPopoverOpen(prev => !prev)
  }

  useEffect(() => {
    if (isPopoverOpen) {
      const timeoutId = setTimeout(() => {
        setIsPopoverOpen(false)
      }, 4000)

      return () => {
        clearTimeout(timeoutId)
      }
    }
  }, [isPopoverOpen])

  useEffect(() => {
    if (!isPopoverOpen) {
      return undefined
    }

    const handleOutsideClick = event => {
      const clickedTrigger =
        triggerRef.current && triggerRef.current.contains(event.target)
      const clickedPopover =
        popoverRef.current && popoverRef.current.contains(event.target)

      if (!clickedTrigger && !clickedPopover) {
        setIsPopoverOpen(false)
      }
    }

    document.addEventListener('click', handleOutsideClick)

    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [isPopoverOpen])

  return (
    <React.Fragment>
      <button
        ref={triggerRef}
        data-test={`tooltip.${name}`}
        id={targetIdRef.current}
        className="popover-primary"
        onClick={toggle}
        type="button"
        tabIndex="-1"
      >
        <i className="fa fa-question-circle" aria-hidden="true" />
      </button>
      <Popover
        innerRef={popoverRef}
        placement={!!toolTipPosition ? toolTipPosition : "auto-start"}
        target={targetIdRef.current}
        trigger="manual"
        isOpen={isPopoverOpen}
      >
        <PopoverHeader>{title}</PopoverHeader>
        <PopoverBody>{tooltip}</PopoverBody>
      </Popover>
    </React.Fragment>
  )
}

PopoverComponent.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  // top, bottom, left, right
  toolTipPosition: PropTypes.string
}

export default PopoverComponent
